import { Alert, Button } from "@mui/material";
import EditTelephone from "@/modules/lead-page/components/lead-info/edit-fields/telephone";
import useEditTelephone from "@/modules/lead-page/hooks/lead-info/edit-telephone.hook";

export default function StatusMobileNumberNotice() {
  const { telephone } = useEditTelephone();
  return (
    <>
      <Alert
        severity="warning"
        action={
          <Button
            color="inherit"
            onClick={() => telephone.setEditTelephoneModalOpen(true)}
          >
            Add number
          </Button>
        }
      >
        Add a mobile number before moving to this status.
      </Alert>
      <EditTelephone
        open={telephone.editTelephoneModalOpen}
        setOpen={telephone.setEditTelephoneModalOpen}
        telephoneHook={telephone}
      />
    </>
  );
}
